import { render, staticRenderFns } from "./AddCoupons.vue?vue&type=template&id=2c67206a&scoped=true&"
import script from "./AddCoupons.vue?vue&type=script&lang=js&"
export * from "./AddCoupons.vue?vue&type=script&lang=js&"
import style0 from "./AddCoupons.vue?vue&type=style&index=0&id=2c67206a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c67206a",
  null
  
)

export default component.exports